import {useQueries} from '@tanstack/react-query'
import {getProductCategoryList} from '@/services/ProductsService/ProductCategory/category'

export const useProductCategoryList = () => {
  const results = useQueries({
    queries: [
      {
        queryKey: ['CATEGORY_LIST'],
        queryFn: getProductCategoryList,
      },
    ],
  })

  return {
    categoryListData: results?.[0]?.data || [],
  }
}
